import React, { useState } from 'react'
import { IconButtonContainer, Tooltip } from './styles'

interface IIconButtonProps {
  onClick: () => void
  tooltip?: string
  active?: boolean
  disabled?: boolean
  'aria-label'?: string
  'data-tour'?: string
  children: React.ReactNode
}

/**
 * Botão com ícone e tooltip que aparece no hover
 */
const IconButton: React.FC<IIconButtonProps> = ({
  onClick,
  tooltip,
  active = false,
  disabled = false,
  'aria-label': ariaLabel,
  'data-tour': dataTour,
  children,
}) => {
  const [showTooltip, setShowTooltip] = useState(false)

  return (
    <IconButtonContainer
      onClick={onClick}
      active={active}
      disabled={disabled}
      aria-label={ariaLabel || tooltip}
      data-tour={dataTour}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      type="button"
    >
      {children}
      {tooltip && showTooltip && <Tooltip>{tooltip}</Tooltip>}
    </IconButtonContainer>
  )
}

export default IconButton
